import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import LogoTiles from '@segment/templates/LogoTiles'

import { trackButtonClick } from '@segment/tracking/scripts'

import { scrollToAnchor } from '@segment/utils/useScrollToAnchor'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Start connecting your data with Segment`,
  button: {
    text: `Create a free account`,
  },
  demoButton: {
    text: `Talk to sales`,
    href: `/demo/`,
  },
}

const GettingStarted = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3" variant="h2">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
        <Content>
          <Button
            size="large"
            color="primary"
            variant="filled"
            tag="a"
            onClick={() => scrollToAnchor(`sign-up-hero-form`, -80)}
          >
            {copy.button.text}
          </Button>
          <Button
            size="large"
            color="primary"
            variant="outlined"
            tag="a"
            href={getAbsoluteUrl(copy.demoButton.href, pageConfig)}
            onClick={() => trackButtonClick({ buttonText: copy.demoButton.text, targetUrl: copy.demoButton.href })}
          >
            {copy.demoButton.text}
          </Button>
        </Content>
      </Copy>

      <LogoTiles />
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export const Copy = styled.div`
  display: grid;
  justify-content: center;
  row-gap: 40px;
  padding: 40px 0 20px;

  white-space: pre-line;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 80px 80px 30px;
  }
`

export const Content = styled.div`
  display: grid;
  max-width: 520px;
  width: 100%;
  margin: 0 auto;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    grid-template-columns: auto;
    max-width: 327px;
  }
`

export default GettingStarted
